export var RichTextStyle;
(function(RichTextStyle) {
    RichTextStyle["Primary"] = "primary";
    RichTextStyle["Alternative"] = "alternative";
    RichTextStyle["Muted"] = "muted";
})(RichTextStyle || (RichTextStyle = {}));
